import { atom } from 'jotai';

export interface GuildOption {
  id: string;
  name: string;
  icon?: string | null;
}

export const guildsAtom     = atom<GuildOption[]>([]);
export const selGuildAtom   = atom<string>('');
export const latencyAtom    = atom<number | null>(null);
